
  import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
  import { Getter, Action } from 'vuex-class';
  import { PromptParameter } from '../../data-access/rephrase';

  @Component({
    name: 'BoxList'
  })
  export default class BoxList extends Vue {
    @Prop() parameterName!: string;

    @Getter('promptParameters', { namespace: 'rephrase' }) promptParameters!: PromptParameter[];
    @Getter('currentPromptId', { namespace: 'rephrase' }) currentPromptId!: number;

    @Action('updatePromptParameters', { namespace: 'rephrase' }) updatePromptParameters!: any;

    @Watch('currentPromptId')
    onCurrentPromptChanged() {
      this.getParameters()
    }

    @Watch('promptParameters')
      onPromptParametersChanged() {
      this.getParameters();
    }

    parameter: any = {}
    listParameters: string[] = []

    created() {
      this.getParameters()
    }

    getParameters() {
      this.parameter = this.promptParameters
      .filter(parameter => parameter.name === this.parameterName)
      .filter(parameter => parameter.promptId === this.currentPromptId)[0];
      this.listParameters = [];
      if (this.parameter) {
        if (this.parameter.value !== "")
          this.listParameters = this.parameter.value.split(', ');
      } else
        this.parameter = { promptId: this.currentPromptId, lang: "en", name: this.parameterName, value: "" }
    }

    pushParameters() {
      this.parameter.value = this.listParameters.join(', ');
      this.updatePromptParameters(this.parameter);
    }

    updateParameter(index: any, element: any) {
      const forbiddenChars = /[{}]/g;
      element.value = element.value.replace(forbiddenChars, '');
      this.$set(this.listParameters, index, element.value);
      this.pushParameters();
    }

    removeParameter(index: any) {
      this.listParameters.splice(index, 1);
      this.pushParameters();
    }

    addParameter() {
      this.listParameters.push('');
    }
  }
